import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'A nossa escolha',
  bestPriceBadge: 'Melhor preço',
};
